import { Component, OnInit, Inject } from '@angular/core';

import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Helper } from '../../Helper';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { CustomValidators } from '../../CustomValidators';


@Component({
  selector: 'app-application-type-popup',
  templateUrl: './application-type-popup.component.html',
  styleUrls: ['./application-type-popup.component.css']
})
export class  ApplicationTypePopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<ApplicationTypePopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    public Helper:Helper ) { 
      console.log(data,"datadatadata")
      

    }

  ngOnInit() {
  }
  editApp(elem){
    this.dialogRef.close(elem);
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
